module.exports = __webpack_public_path__ + "img/alloys.57a883d.jpg";